const RULED_BUS = ["videovigilancia", "control_acceso", "alarma", "redes"];
const BIS_ONLY = ["ampliacion", "reemplazo"];

export const movementOptions = (serviceTypes = [], bu, current) =>
  serviceTypes.filter((s) => s.code === current || (
    (!s.business_unit_codes || s.business_unit_codes.includes(bu)) && !(BIS_ONLY.includes(s.code) && RULED_BUS.includes(bu))
  )).map((s) => (bu === "gps" && s.code === "mant_preventivo" ? { ...s, name: "Mantenimiento" } : s));

export const DESTINATIONS = [["cliente", "Cliente"], ["tssmx", "TSSMX (resguardo)"], ["garantia", "Garantía (fabricante/distribuidor)"], ["destruccion", "Destrucción"], ["otro", "Otro"]];
